import React, { Component } from 'react'
import { func, bool } from 'prop-types'
import { translate } from 'react-i18next'
import { ResetPassword as validation } from './validators'
import { validateReferences } from '../../utilities/validators'
import { Input } from '../ui/inputs/Input'
import { Loader } from '../ui/states/Loader'

class ResetPasswordComponent extends Component {
  constructor () {
    super()
    this.state = {
      password: ''
    }
  }

  validate () {
    const { isValid } = validateReferences(this.refs)
    if (!isValid) {
      return false
    }
    return true
  }

  submit () {
    const { onSubmit } = this.props
    if (onSubmit) {
      onSubmit(this.state.password)
    }
  }

  render () {
    const { t } = this.props
    return (
      <div>
        <Input ref='password' value={this.state.password} onChange={(v) => this.setState({ password: v })} label={t('common:fields:password')} name='password' type='password' rules={validation} />
        <Input ref='confirm' associated={() => this.refs['password'].state} label={t('common:fields:confirm')} name='passwordConfirm' type='password' />
        {
          this.props.loading
          ? <Loader size='small' />
          : <button
            onClick={() => this.validate() && this.submit()}
            className='btn--default layout--centered'>
            {t('common:buttons:modify')}
          </button>
        }
      </div>
    )
  }
}

ResetPasswordComponent.propTypes = {
  t: func,
  loading: bool,
  onSubmit: func
}

export const ResetPassword = translate()(ResetPasswordComponent)



// WEBPACK FOOTER //
// ./src/components/authentication/ResetPassword.js